import dayjs, { Dayjs } from 'dayjs';
import { getAppointmentDateRange } from './AppointmentDateRange';

/**
 * Parametri di una GetAll appuntamenti che decidono quali appuntamenti
 * arrivano: data e vista (cioè l'intervallo di date) e filtri.
 */
export interface ParametriRichiestaAppuntamenti {
  selectedDate: Date;
  checkedServices: string[];
  checkedStudi: string[];
  checkedUsers: string[];
  checkedPointOfSales: string[];
  view?: string;
  email?: string;
  externalCustomerCode?: string;
  isTabClient?: boolean;
}

/**
 * Intervallo di date della GetAll: quello della vista, oppure, per la tab
 * agenda della scheda cliente, dalla data selezionata al primo giorno del mese
 * dopo. Dayjs o stringhe, come la richiesta li ha sempre mandati.
 */
export function getIntervalloRichiestaAppuntamenti(
  selectedDate: Date,
  view = 'Day',
  isTabClient = false
): [Dayjs | string, Dayjs | string] {
  if (!isTabClient) {
    const [inizio, fine] = getAppointmentDateRange(selectedDate, view);
    return [inizio, fine];
  }
  return [
    dayjs(selectedDate).format('YYYY-MM-DD'),
    dayjs(selectedDate).endOf('month').add(1, 'day').format('YYYY-MM-DD'),
  ];
}

/**
 * Chiave di una GetAll appuntamenti: intervallo di date, come giorni, e filtri.
 * La calcola il caricamento sui parametri della richiesta e la salva insieme
 * alla lista; la pagina la calcola sui filtri correnti. Se coincidono, la lista
 * in redux è quella della data e dei filtri mostrati: nei primi 50 ms dopo un
 * cambio, e finché la risposta nuova non arriva, la lista è ancora quella
 * vecchia anche se il caricamento risulta finito.
 */
export function getChiaveRichiestaAppuntamenti({
  selectedDate,
  view,
  isTabClient,
  checkedServices,
  checkedStudi,
  checkedUsers,
  checkedPointOfSales,
  email,
  externalCustomerCode,
}: ParametriRichiestaAppuntamenti): string {
  const [inizio, fine] = getIntervalloRichiestaAppuntamenti(
    selectedDate,
    view,
    isTabClient
  );
  return JSON.stringify([
    dayjs(inizio).format('YYYY-MM-DD'),
    dayjs(fine).format('YYYY-MM-DD'),
    checkedServices,
    checkedStudi,
    checkedUsers,
    checkedPointOfSales,
    // Senza cliente la richiesta non manda l'email: vuota e assente sono uguali
    email || '',
    externalCustomerCode ?? '',
  ]);
}
